import { render, staticRenderFns } from "./example_section.vue?vue&type=template&id=2e61a64a"
import script from "./example_section.vue?vue&type=script&lang=js"
export * from "./example_section.vue?vue&type=script&lang=js"
import style0 from "./example_section.vue?vue&type=style&index=0&id=2e61a64a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports